// --------------------------------------------------------------------------
// videoBanner.js
// --------------------------------------------------------------------------
// Toggle the display of the event summary on event tiles
// --------------------------------------------------------------------------

EC.videoBanner = function () {

    'use strict';

    function init () {

        const $homeBanner = $('.js-video-banner');

        if ($homeBanner.length > 0 && $(window).width() > 767){
            const sections = ['connect', 'engage', 'grow', 'play'];

            const banner = new videoBanner($homeBanner, sections);
        }
    }


    class videoBanner {
        constructor ($el, sections) {
            this.sectionsData = sections;
            this.sections = [];
            this.$fallback = $el.find('#js-video-banner__fallback');
            this.$videoWrap = $el.find('#js-video-banner__video-wrap');
            this.$video = $el.find('#js-video-banner__video');
            this.video = this.$video[0];
            this.displayVideo = this.displayVideo.bind(this);
            this.activeSection = 0;
            this.switchTimestamps = [2.5, 8, 13.7, 20];

            this.sectionsData.forEach(section => {
                this.addSection(section);
            });

            this.setEventListeners();
            this.video.load();
        }

        addSection (section) {
            const newSection = new videoBannerSection(section, this);
            this.sections.push(newSection);
        }

        setEventListeners () {
            this.$video.on('canplaythrough', this.displayVideo);
            this.$video.on('timeupdate', () => this.onTimeUpdate());
            this.$video.on('ended', () => this.videoEnded());
        }

        displayVideo () {
            this.$fallback.addClass('js-fadeout');
            this.$videoWrap.addClass('js-fadein');
            this.video.play();
            this.$video.off('canplaythrough', this.displayVideo);
            this.sections[0].activate();
        }

        onTimeUpdate () {
            const currentTime = this.video.currentTime;

            if (currentTime > 0 && currentTime <= this.switchTimestamps[0]){
                this.switchSection(0);
            }
            else if (currentTime > this.switchTimestamps[0] && currentTime <= this.switchTimestamps[1]) {
                this.switchSection(1);
            }
            else if (currentTime > this.switchTimestamps[1] && currentTime <= this.switchTimestamps[2]) {
                this.switchSection(2);
            }
            else if (currentTime > this.switchTimestamps[2] && currentTime <= this.switchTimestamps[3]) {
                this.switchSection(3);
            }
            else if (currentTime > this.switchTimestamps[3] && currentTime <= this.video.duration) {
                this.switchSection(0);
            }
        }

        switchSection (newSection) {
            if (this.activeSection == newSection){
                return;
            }
            else {
                this.sections[newSection].activate();
                this.sections[this.activeSection].deactivate();
                this.activeSection = newSection;
            }
        }
    }

    class videoBannerSection {
        constructor (section, banner) {
            this.$panel = $('#js-video-banner__panel--' + section);
            this.banner = banner;
            this.order = banner.sections.length;
        }

        activate () {
            this.$panel.addClass('b-home-video-banner__panel--active');
        }

        deactivate () {
            this.$panel.removeClass('b-home-video-banner__panel--active');
        }
    }

    return {
        init: init
    };

}();
